import { useMutation, useQueryClient } from "@tanstack/react-query";
import { notification } from "antd";
import { ITCodeRequestService } from "../../../../../services/it-code-request/itCodeRequest.service";

interface IVariable {
  id: string;
  body: any;
}

export const useUpdatePCR = () => {
  const queryClient = useQueryClient();
  const { mutate, ...restMutation } = useMutation({
    mutationFn: ({ id, body }: IVariable) => ITCodeRequestService.updateITCodeRequest(id, body),
  });

  const updatePCRequest = (
    vars: IVariable,
    options?: {
      onSuccess?: (r: any) => void;
      successText?: string;
      errorText?: string;
    },
  ) => {
    mutate(vars, {
      onSuccess(response: any) {
        queryClient.invalidateQueries({
          queryKey: ["code-process-requests"],
        });
        notification.success({
          message: "Thành công!",
          description: options?.successText ?? `Duyệt yêu cầu thành công.`,
        });
        if (options?.onSuccess) options.onSuccess(response);
      },
      onError() {
        notification.error({
          message: "Thất bại",
          description: options?.errorText ?? `Duyệt yêu cầu thất bại.`,
        });
      },
    });
  };
  
  return { mutate, updatePCRequest, ...restMutation };
};
